// extracted by mini-css-extract-plugin
export default {"toggles":"SideField_toggles__bIhi8","spikesContainer":"SideField_spikesContainer__9NSZQ","spikes":"SideField_spikes__SP22c"};